import api from '../services/api';
import { ITreatmentItem } from '../shared/interfaces';

export const postTreatmentItem = async (
  payload: any,
): Promise<ITreatmentItem> => {
  const response = await api.post('/treatments-items', payload);
  return response.data;
};

export const patchTreatmentItem = async (
  id: string | undefined,
  payload: any,
): Promise<ITreatmentItem> => {
  if (!id) {
    throw new Error('ID do tratamento não fornecido.');
  }
  const response = await api.patch(`/treatments-items/${id}`, payload);
  return response.data;
};

export const deleteTreatmentItem = async (
  id: string | undefined,
): Promise<ITreatmentItem> => {
  if (!id) {
    throw new Error('ID do item não fornecido.');
  }
  const response = await api.delete(`/treatments-items/${id}`);
  return response.data;
};
